module.exports = __webpack_public_path__ + "static/media/rounded-add-cross-icon.245bfd2e.svg";